export const TOO_MANY_LOGIN_ATTEMPT_CODES = new Set([
	"LimitExceededException",
	"TooManyFailedAttemptsException",
]);

export const isTooManyLoginAttemptsError = (error) =>
	TOO_MANY_LOGIN_ATTEMPT_CODES.has(error?.response?.data?.code);

export const resolveLoginErrorVariant = (error) => {
	if (error?.response?.data?.code === "MissingNationalId") {
		return "missing-national-id";
	}

	if (isTooManyLoginAttemptsError(error)) {
		return "too-many-login-attempts";
	}

	if (typeof error?.message === "string" && error.message.includes("verification")) {
		return "invalid-verification-code";
	}

	return "incorrect-password";
};
